<modal #modal
       [allowClickOut]="!hasSelectedDifferentMealPlans">
    <ng-container class="modal-header-content">
        <div *ngIf="!view.loaders.getHostRooms && selectedQuotation && selectedQuotation.hotels"
             class="details-modal-header">
            <hotel-resume [hotel]="selectedHotelProperty"
                          [currency]="currency"
                          [currencies]="currencies"
                          [isShowRooms]="false"
                          [mealPlan]="selectedHotelProperty?.mealplan"></hotel-resume>

            <btn type="actionDo"
                 (onClick)="hide()"
                 [value]="wording.close"
                 [disableIf]="hasSelectedDifferentMealPlans">
            </btn>
        </div>

        <div *ngIf="view.loaders.getHostRooms" class="details-modal-header">
            ...
        </div>
    </ng-container>

    <ng-container class="modal-sub-header-content">
        <notification class="gpp-notification" *ngIf="gppErrorNotification.active" [type]="gppErrorNotification.type">
            {{ gppErrorNotification.message }}
        </notification>

        <notification class="language-notification" *ngIf="selectedQuotation && hasDifferentLanguage()"
                      type="warning">
            <fa-icon [icon]="iconExclamation"></fa-icon>
            {{ wording.languagesWarning }}
        </notification>

        <notification class="different-notification" *ngIf="hasSelectedDifferentMealPlans"
                      type="warning">
            <fa-icon [icon]="iconExclamation"></fa-icon>
            {{ wording.differentMealplansChosen }}
        </notification>
    </ng-container>

    <ng-container class="modal-body-content">
        <ng-container *ngIf="!view.loaders.getQuotation && selectedQuotation && !view.loaders.getHostRooms">
            <div class="menu-container">
                <menu-details [items]="menuDetailsItems"
                              (onChangeTab)="changeTab($event)">
                </menu-details>
                <hotel-informations-alternative-select permissionShow="shared.host.show" *ngIf="selectedHotelProperty"
                                                       [isActive]="selectedMenuDetailsItem !== 'offers'"
                                                       [currentProperty]="selectedHotelProperty"
                                                       [propertyAlternatives]="searchResultAlternatives"
                                                       [initWithGiata]="preferGiataProperty"
                                                       [isWithGiata]="isWithGiata"
                                                       [isPermModalAlternative]="isPermModalAlternative"
                                                       (currentPropertyChange)="changeSelectedHotelProperty($event)">
                </hotel-informations-alternative-select>
            </div>

            <offers [hidden]="selectedMenuDetailsItem !== 'offers'"
                    [data]="{ selectedQuotation: selectedQuotation.hotels ? selectedQuotation.hotels[selectedQuotation.selected] : null, loaders: view.loaders }"
                    [travellers]="travellers"
                    [config]="hasSelectedDifferentMealPlans ? {} : config"
                    [configSharedHotel]="configSharedHotel"
                    [currency]="currency"
                    [isWithGiata]="isWithGiata"
                    [currencies]="currencies"
                    [propertyAlternatives]="searchResultAlternatives"
                    [otherRoomsList]="selectedQuotation.hotels ? selectedQuotation.hotels[selectedQuotation.selected]?.rooms : null"
                    (onGetQuotation)="getQuotation($event)"
                    (onGetOtherRooms)="getOtherRooms($event)"
                    (onChangeRoom)="changeRoom($event)"></offers>
            <description *ngIf="selectedMenuDetailsItem === 'description' && selectedHotelProperty"
                         [description]="selectedHotelProperty"></description>

            <informations *ngIf="selectedMenuDetailsItem === 'informations' && selectedHotelProperty"
                          [informations]="selectedHotelProperty">

                <map class="flex-3" *ngIf="selectedHotelProperty.geoposition; else noGeoposition"
                     [configuration]="mapConfiguration"
                     [defaultZoom]="17"
                     [points]="[selectedHotelProperty.geoposition | toMarkerPoint]"></map>
                <ng-template #noGeoposition>
                    <em class="noGeoposition">
                       {{wording.noGeoposition}}
                    </em>
                </ng-template>
            </informations>
        </ng-container>

        <loader *ngIf="!selectedQuotation || view.loaders.getHostRooms" [message]="wording.roomsLoading"></loader>
        <loader *ngIf="view.loaders.getQuotation" [message]="wording.generateQuotation"></loader>
    </ng-container>
</modal>
